<template>
  <section class="banner-section">
    <!-- 배경 이미지 -->
    <div class="banner-bg">
      <div 
        class="bg-image" 
        :style="{ backgroundImage: `url(${bgImage})` }"
      ></div>
      <div class="bg-overlay"></div>
    </div>

    <!-- 메인 콘텐츠 -->
    <div class="banner-content">
      <!-- 컨텐츠 박스 -->
      <div class="content-box">
        <!-- 상단 라벨 -->
        <div class="top-label">
          <span class="label-badge">PREMIUM</span>
          <span class="label-text">CHEONGJU TECHNOPOLIS</span>
        </div>

        <!-- 메인 타이틀 -->
        <div class="main-title">
          <h1>
            <span class="title-row">
              <span class="title-word" style="animation-delay: 0s">청주</span>
              <span class="title-word" style="animation-delay: 0.1s">테크노폴리스</span>
            </span>
            <span class="title-row">
              <span class="title-word highlight" style="animation-delay: 0.2s">레이원시티</span>
            </span>
          </h1>
        </div>

        <!-- 서브 카피 -->
        <p class="sub-copy">
          첨단과 자연이 공존하는 프리미엄 라이프
        </p>

        <!-- 키워드 태그 -->
        <div class="keyword-tags">
          <span class="tag">첨단도시</span>
          <span class="tag">프리미엄</span>
          <span class="tag">교통중심</span>
          <span class="tag">자연친화</span>
        </div>

        <!-- CTA 버튼 -->
        <div class="cta-area">
          <router-link to="/support" class="cta-btn primary">
            <span>관심고객 등록</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </router-link>
          <a href="tel:1600-9768" class="cta-btn secondary">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
            </svg>
            <span>1600-9768</span>
          </a>
        </div>
      </div>
    </div>

    <!-- 하단 퀵 정보 -->
    <div class="bottom-info">
      <div class="info-item">
        <span class="info-number">1,800+</span>
        <span class="info-label">세대 규모(예정)</span>
      </div>
      <div class="info-divider"></div>
      <div class="info-item">
        <span class="info-number">2029</span>
        <span class="info-label">입주 예정</span>
      </div>
      <div class="info-divider"></div>
      <div class="info-item">
        <span class="info-number">59 ~ 84</span>
        <span class="info-label">평형 (㎡)</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BannerSection',
  data() {
    return {
      bgImage: require('@/assets/banner/banner1.jpg')
    }
  }
}
</script>

<style scoped>
.banner-section {
  width: 100%;
  height: 100vh;
  min-height: 700px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: -80px;
}

/* 배경 */
.banner-bg {
  position: absolute;
  inset: 0;
  z-index: 1;
}

.bg-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  animation: zoomIn 20s ease-out infinite alternate;
}

@keyframes zoomIn {
  from { transform: scale(1); }
  to { transform: scale(1.05); }
}

.bg-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.92) 0%,
    rgba(255, 255, 255, 0.85) 40%,
    rgba(255, 255, 255, 0.4) 100%
  );
}

/* 메인 콘텐츠 */
.banner-content {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 1400px;
  padding: 0 40px;
  margin-top: 40px;
}

/* 콘텐츠 박스 */
.content-box {
  max-width: 700px;
}

/* 상단 라벨 */
.top-label {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
  animation: fadeInUp 0.8s ease forwards;
  opacity: 0;
}

.label-badge {
  padding: 6px 14px;
  background: var(--main-color1);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
  border-radius: 4px;
}

.label-text {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 3px;
  color: var(--main-color1);
}

/* 메인 타이틀 */
.main-title {
  margin-bottom: 24px;
}

.main-title h1 {
  margin: 0;
}

.title-row {
  display: block;
  overflow: hidden;
  line-height: 1.15;
}

.title-word {
  display: inline-block;
  font-size: 68px;
  font-weight: 800;
  letter-spacing: -2px;
  margin-right: 12px;
  color: #1a1a1a;
  animation: slideUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  opacity: 0;
  transform: translateY(100%);
}

.title-word.highlight {
  color: var(--main-color1);
}

@keyframes slideUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 서브 카피 */
.sub-copy {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 1px;
  color: #555;
  margin-bottom: 28px;
  animation: fadeInUp 0.8s ease 0.5s forwards;
  opacity: 0;
}

/* 키워드 태그 */
.keyword-tags {
  display: flex;
  gap: 10px;
  margin-bottom: 36px;
  animation: fadeInUp 0.8s ease 0.6s forwards;
  opacity: 0;
}

.tag {
  padding: 10px 20px;
  background: rgba(139, 35, 50, 0.08);
  border: 1px solid rgba(139, 35, 50, 0.2);
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  color: var(--main-color1);
  transition: all 0.3s;
}

.tag:hover {
  background: var(--main-color1);
  color: #fff;
  transform: translateY(-2px);
}

/* CTA 버튼 */
.cta-area {
  display: flex;
  gap: 14px;
  animation: fadeInUp 0.8s ease 0.7s forwards;
  opacity: 0;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 18px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.cta-btn.primary {
  background: var(--main-color1);
  color: #fff;
  box-shadow: 0 8px 30px rgba(139, 35, 50, 0.3);
}

.cta-btn.primary:hover {
  background: var(--main-color2);
  transform: translateY(-3px);
  box-shadow: 0 12px 40px rgba(139, 35, 50, 0.4);
}

.cta-btn.primary svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s;
}

.cta-btn.primary:hover svg {
  transform: translateX(4px);
}

.cta-btn.secondary {
  background: #fff;
  border: 2px solid var(--main-color1);
  color: var(--main-color1);
}

.cta-btn.secondary:hover {
  background: var(--main-color1);
  color: #fff;
  transform: translateY(-3px);
}

.cta-btn.secondary svg {
  width: 20px;
  height: 20px;
}

/* 하단 퀵 정보 */
.bottom-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  padding: 32px 40px;
  background: var(--main-color1);
  z-index: 20;
  animation: slideUpInfo 0.8s ease 1s forwards;
  opacity: 0;
  transform: translateY(100%);
}

@keyframes slideUpInfo {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.info-number {
  font-size: 32px;
  font-weight: 700;
  color: #fff;
}

.info-label {
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: 1px;
}

.info-divider {
  width: 1px;
  height: 50px;
  background: rgba(255, 255, 255, 0.3);
}

/* 반응형 */
@media (max-width: 1024px) {
  .banner-section {
    margin-top: -65px;
  }

  .banner-content {
    padding: 0 30px;
  }

  .title-word {
    font-size: 52px;
  }

  .sub-copy {
    font-size: 18px;
  }

  .bottom-info {
    gap: 40px;
    padding: 28px 30px;
  }

  .info-number {
    font-size: 26px;
  }
}

@media (max-width: 768px) {
  .banner-section {
    min-height: 100vh;
  }

  .banner-content {
    padding: 0 24px;
    margin-top: 20px;
  }

  .bg-overlay {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.95) 0%,
      rgba(255, 255, 255, 0.9) 60%,
      rgba(255, 255, 255, 0.7) 100%
    );
  }

  .content-box {
    text-align: center;
  }

  .top-label {
    justify-content: center;
    flex-wrap: wrap;
  }

  .label-text {
    font-size: 12px;
    letter-spacing: 2px;
  }

  .title-row {
    text-align: center;
  }

  .title-word {
    font-size: 36px;
    letter-spacing: -1px;
    margin-right: 8px;
  }

  .sub-copy {
    font-size: 15px;
  }

  .keyword-tags {
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }

  .tag {
    padding: 8px 16px;
    font-size: 13px;
  }

  .cta-area {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .cta-btn {
    width: 100%;
    max-width: 300px;
    justify-content: center;
    padding: 16px 28px;
    font-size: 15px;
  }

  .bottom-info {
    gap: 24px;
    padding: 24px 20px;
  }

  .info-number {
    font-size: 22px;
  }

  .info-label {
    font-size: 12px;
  }

  .info-divider {
    height: 40px;
  }
}

@media (max-width: 480px) {
  .title-word {
    font-size: 30px;
    display: block;
    margin-right: 0;
  }

  .bottom-info {
    gap: 16px;
  }

  .info-number {
    font-size: 20px;
  }

  .info-label {
    font-size: 11px;
  }

  .info-divider {
    height: 32px;
  }
}
</style>